import createPlaybackService from './Playback/createPlaybackService';
import createPrecisionService from './Precision/createPrecisionService';
import createResumePointsService from './ResumePoints/createResumePointsService';
import createConcurrencyService from './Concurrency/createConcurrencyService';
import createUserActionsService from './UserActions/createUserActionsService';
import createUserActionsWatchedService from './UserActionsWatched/createUserActionsWatchedService';

class ApiServices {
    constructor(middleware) {
        const configStoreUpdate$ = middleware.state.stores.config.update$;
        const { handleError } = middleware.errorsHandler;

        this.playback = createPlaybackService(configStoreUpdate$, handleError);
        this.resumePoints = createResumePointsService(configStoreUpdate$, handleError);
        this.precision = createPrecisionService(configStoreUpdate$, handleError);
        this.concurrency = createConcurrencyService(configStoreUpdate$, handleError);
        this.userActions = createUserActionsService(configStoreUpdate$, handleError);
        this.userActionsWatched = createUserActionsWatchedService(configStoreUpdate$, handleError);
    }
}

export default ApiServices;
